import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export const Breadcrumbs = ({ items }) => {
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className="max-w-7xl mx-auto px-6 sm:px-8 pt-24 sm:pt-28 pb-4"
    >
      <ol className="flex items-center gap-2 text-xs sm:text-sm text-zinc-500 flex-wrap">
        <li>
          <Link
            to="/"
            className="flex items-center gap-1.5 hover:text-zinc-950 transition-colors"
            data-testid="breadcrumb-home"
          >
            <Home size={13} />
            Anasayfa
          </Link>
        </li>
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-2">
            <ChevronRight size={13} className="text-zinc-400" />
            {item.href ? (
              <Link to={item.href} className="hover:text-zinc-950 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-zinc-950 font-medium truncate max-w-[220px] sm:max-w-none">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
